import { render } from "./RiskTab.vue?vue&type=template&id=f82ef1dc&scoped=true"
import script from "./RiskTab.vue?vue&type=script&lang=js"
export * from "./RiskTab.vue?vue&type=script&lang=js"

import "./RiskTab.vue?vue&type=style&index=0&id=f82ef1dc&scoped=true&lang=css"
import "./RiskTab.vue?vue&type=style&index=1&id=f82ef1dc&scoped=true&lang=css"
import "./RiskTab.vue?vue&type=style&index=2&id=f82ef1dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f82ef1dc"]])

export default __exports__